import { Injectable } from "@angular/core";
import { AccountsApiService } from "../api/accounts-api.service";
import { CatalogApiService } from "../api/catalog-api.service";
import { AuthManagerService } from "../auth/auth-manager.service";
import { UserRole } from "../auth/auth.model";
import { FeatureDecimalFormat } from "../model/catalog/catalog.model";

@Injectable()
export class GlobalStorageService {
    decimalFormats: Array<FeatureDecimalFormat>;
    isReturn: boolean;
    degree: number;
    hsa: number;

    constructor(private catalogApiService: CatalogApiService,
                private accountsApiService: AccountsApiService,
                private authManagerService: AuthManagerService) {
        this.catalogApiService.getFeatureDecimalFormats().subscribe(data => {
            this.decimalFormats = data;
            this.decimalFormats = this.decimalFormats.concat(FEATURES_DECIMAL_FORMATS);
        });
        if(this.authManagerService.currentUser?.role !== UserRole.SUPERADMIN) {
            this.accountsApiService.getReturn().subscribe(value => this.isReturn = value);
            this.accountsApiService.getDegree().subscribe(degree => this.degree = degree);
            this.accountsApiService.getHsa().subscribe(hsa => this.hsa = hsa);
        }
    }
}

const FEATURES_DECIMAL_FORMATS: Array<FeatureDecimalFormat> = [{"featureName": "Eccentricity", "decimalFormat": 2},
                                  {"featureName": "RadiusFlach", "decimalFormat": 2},
                                  {"featureName": "RadiusSteil", "decimalFormat": 2},
                                  {"featureName": "HHDia", "decimalFormat": 1},
                                  {"featureName": "Nasal", "decimalFormat": 2},
                                  {"featureName": "Temporal", "decimalFormat": 2},
                                  {"featureName": "Superior", "decimalFormat": 2},
                                  {"featureName": "Inferior", "decimalFormat": 2}]